module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'v8n7sh8w',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
